import { VehicleType } from 'types';

export const verticals: { [k: string]: VehicleType } = {
  CITADINE: 'AUTO',
  MOYENNE_BERLINE: 'AUTO',
  GRANDE_BERLINE: 'AUTO',
  BREAK: 'AUTO',
  MONOSPACE: 'AUTO',
  COUPE: 'AUTO',
  CABRIOLET: 'AUTO',
  PICK_UP: 'AUTO',
  TOUS_CHEMINS: 'AUTO',
  VOITURETTE: 'AUTO',
  VOITURE_DE_COLLECTION: 'AUTO',
  REMORQUES_SEULS: 'UTILITAIRE',
  VEHICULE_SOCIETE: 'AUTO',
  FOURGON_MOINS_3T5: 'UTILITAIRE',
  MINIBUS: 'UTILITAIRE',
  CAMION_PLUS_3T5: 'UTILITAIRE',
  FOURGONETTE: 'UTILITAIRE',
  FOURGON_AMENAGE: 'CARAVANE',
  CAPUCINE: 'CARAVANE',
  PROFILE: 'CARAVANE',
  INTEGRAL: 'CARAVANE',
  MOBIL_HOME: 'CARAVANE',
  CARAVANNE: 'CARAVANE',
  CUSTOM: 'MOTO',
  OFFROAD: 'MOTO',
  ROADSTER: 'MOTO',
  GT: 'MOTO',
  MINI_MOTO: 'MOTO',
  MOBYLETTE: 'MOTO',
  SUPERMOTARD: 'MOTO',
  TRAIL: 'MOTO',
  SPORTIVE: 'MOTO',
  QUAD: 'MOTO',
  SCOOTER: 'MOTO',
  SIDE_CAR: 'MOTO',
  SIDE_CARS: 'MOTO',
  MOTO_DE_COLLECTION: 'MOTO',
  REMORQUE_PORTE_MOTO: 'MOTO',
  ACCESSOIRES: 'MOTO',
  RECHERCHE: 'MOTO',
  DIVERS_MOTO: 'MOTO',
};
